import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzUploadChangeParam, NzUploadFile } from 'ng-zorro-antd/upload';
import { findIndex, Observable, Observer } from 'rxjs';
import { CommonService } from 'src/@services/common.service';
import { FormService } from 'src/@services/form.service';
import { InnerPagesService } from 'src/app/pages/common-layout/inner-pages.service';
import { CommonPagesService } from '../../common-pages.service';
import data from 'src/assets/json/states.json';
import {
  AccountType,
  AssignmentUser,
  ResponseStatus,
  ValidationMessage,
} from '../../enum';
@Component({
  selector: 'app-add-update-account',
  templateUrl: './add-update-account.component.html',
  styleUrls: ['./add-update-account.component.scss'],
  standalone: false,
})
export class AddUpdateAccountComponent implements OnInit {
  dropdownList: any[] = [];
  accountsData: any[] = [];
  selectedItems: any[] = [];
  sitesData: any[] = [];
  uploadResult: any;
  validationMessage = ValidationMessage;
  isVisibleAccountDrawer = true;
  isLoadingUpload = false;
  isLoadingOne = false;
  LineStreetAddress = false;
  accountDrawerTitle: any;
  @Output() hideAccountDrawer = new EventEmitter();
  @Input() selectedData: any;
  @Input() accountName: any;
  @Input() SelectedAccountTab: any;
  @Input() usersList: any;
  unitValue: string[] = [];
  unitsList: any[] = [];
  selectedUnits: any[] = [];
  contractArr: any[] = [];
  pageSize: number = 10;
  sortBy: any = 'asc';
  sortField: string = 'CreatedOn';
  searchText: any = '';
  pageNumber: number = 1;
  filterByStatus: any = 'All';
  passwordVisible = false;
  contractArray: any = [];
  listOfStates: any = data.States;
  listOfType: any[] = [];
  listOfAgencies: any[] = [];
  unitsArray: any[] = [];
  nodes: any[] = [];
  currentAccountDetails: any;
  ListFile: any = [];
  selectedAccounts: any[] = [];
  selectedSites: any[] = [];
  showAccountsInvalidMessage: boolean = false;
  showSitesInvalidMessage: boolean = false;
  show2FAToggle: boolean = false;
  status = 'Visible';
  deleteIcon: any;
  url: any;
  name: any;
  uploadFlag: any = false;
  fileList: any;
  uploadedContractFiles: any[] = [];
  getAgencyDetails: any;
  userDetails: any;
  fileUploadFlag: any = false;
  @ViewChild('zipcode') zipcode: any;
  @ViewChild('zipcode') actype: any;
  @ViewChild('contractUploadInput') contractUploadInput: any;
  uploadedContractFile: any;
  selectedRoles: { [key: string]: string } = {};
  usersOGList: any[] = []; // Copy of usersList to store selected users
  selectedUserIds = new Set<string>();


  tempSelectedAssignmentUsers: any = {
    projectManager: [],
    director: [],
    accountManager: [],
    executive: [],
    seniorAccountManager: [],
    financeManager: [],
  };

  assignmentRoles = [
    { value: AssignmentUser.ProjectManager, label: 'Project Manager', key: 'projectManager' },
    { value: AssignmentUser.Director, label: 'Director', key: 'director' },
    { value: AssignmentUser.AccountManager, label: 'Account Manager', key: 'accountManager' },
    { value: AssignmentUser.Executive, label: 'Executive', key: 'executive' },
    {
      value: AssignmentUser.SeniorAccountManager,
      label: 'Senior Account Manager',
      key: 'seniorAccountManager',
    },
    { value: AssignmentUser.FinanceManager, label: 'Finance Manager', key: 'financeManager' },
  ];

  // Dynamically generated assignment roles based on enum
  selectedRole: number | null = null;

  constructor(
    public _cS: CommonService,
    private _cpS: CommonPagesService,
    public _fS: FormService,
    private msg: NzMessageService,
    private _iS: InnerPagesService,
    private fb: FormBuilder
  ) {
    _fS.accountForm_fb();

    this.assignmentRoles.forEach((role) => {
      this._fS.accountForm.addControl(
        'assignmentUser_' + role.key,
        this.fb.control(null)
      );
    });
    this._fS.contractupload = new FormData();
  }

  ngOnInit(): void {
    this.getAllAgencys();
    this.getAllAccountTypesDropdown();
    //set all userList options to enabled
    this.usersList.forEach((user: any) => {
      user.disabled = false;
    });

    this.usersOGList = JSON.parse(JSON.stringify(this.usersList));

    //while edit change modal title
    this.selectedData != null
      ? (this.accountDrawerTitle =
        'Edit Account (' + this.selectedData.name + ')')
      : (this.accountDrawerTitle =
        'Add New ' + (this.SelectedAccountTab == AccountType.SupplierBank ? 'Supplier Bank ' : (this.SelectedAccountTab == AccountType.Supplier ? 'Supplier ' : 'Operator ')) + 'Account');

    this.accountName = this.SelectedAccountTab == AccountType.Supplier ? 'Parent Supplier' : 'Account name';
    this.getSelectedAccountDetails();
    this.updateAccountFormValidations();
  }

  updateAccountFormValidations() {
    const addressControls = ['address1', 'city', 'state', 'zipcode', 'country'];

    if (this.SelectedAccountTab === 1) {
      // Remove validators
      addressControls.forEach(field => {
        const control = this._fS.accountForm.get(field);
        if (control) {
          control.clearValidators();
          control.updateValueAndValidity();
        }
      });
    } else {
      // Re-add validators
      this._fS.accountForm.get('address1')?.setValidators([Validators.required, Validators.pattern(/.*\S.*/)]);
      this._fS.accountForm.get('city')?.setValidators([Validators.required, Validators.pattern(/.*\S.*/)]);
      this._fS.accountForm.get('state')?.setValidators([Validators.required]);
      this._fS.accountForm.get('zipcode')?.setValidators([Validators.required, Validators.pattern(/.*\S.*/)]);
      this._fS.accountForm.get('country')?.setValidators([Validators.required]);

      addressControls.forEach(field => {
        const control = this._fS.accountForm.get(field);
        if (control) {
          control.updateValueAndValidity();
        }
      });
    }
  }

  Onclick(e: any) {
    e.target.value = null;
  }
  // disableEnableFromUsersList(event: any, key: any) {
  //   // if (event) {
  //   //   //remove selected user from usersList
  //   //   const index = this.usersList.findIndex(
  //   //     (user: any) => user.id === event
  //   //   );
  //   //   if (index !== -1) {
  //   //     //make that option disabled
  //   //     this.usersList[index].disabled = true;
  //   //     this.tempSelectedAssignmentUsers[key].push(this.usersList[index]);
  //   //     // this.usersList.splice(index, 1);
  //   //   }
  //   // }
  //   if (event) {
  //     if (this.selectedData) {
  //       //add selectedData.assignment to tempSelectedAssignmentUsers if it doesn't exist
  //       if (!this.selectedData.assignment) {
  //         this.selectedData.assignment = {};

  //         this.usersList.forEach((user: any) => {
  //           user.disabled = user.id === event;
  //         });
  //       } else {
  //         // if (this.selectedData.assignment[key]) {
  //         //   this.tempSelectedAssignmentUsers[key] = this.selectedData.assignment[key];
  //         // }

  //         const matchedUser = this.usersList.find((user: any) => user.id === event);
  //         if (matchedUser) {
  //           this.tempSelectedAssignmentUsers[key].push(matchedUser);
  //         }


  //         Object.keys(this.tempSelectedAssignmentUsers).forEach((key) => {
  //           // if (key.includes('assignmentUser_')) {          
  //           // const selectedUserId = this.selectedData.assignment[key][0]?.id;
  //           const selectedUserId =
  //             this.tempSelectedAssignmentUsers[key]?.[0]?.id;
  //           if (selectedUserId) {
  //             const index = this.usersList.findIndex(
  //               (user: any) => user.id === selectedUserId
  //             );

  //             if (index !== -1) {
  //               //make that option disabled
  //               this.usersList[index].disabled = true;
  //               // this.usersList.splice(index, 1);
  //             }
  //             this.usersList = [...this.usersList];
  //           }
  //           // }
  //         });

  //       }
  //     } else {

  //       const matchedUser = this.usersList.find((user: any) => user.id === event);
  //       if (matchedUser) {
  //         this.tempSelectedAssignmentUsers[key].push(matchedUser);
  //       }

  //       Object.keys(this.tempSelectedAssignmentUsers).forEach((key) => {
  //         // if (key.includes('assignmentUser_')) {          
  //         // const selectedUserId = this.selectedData.assignment[key][0]?.id;
  //         const selectedUserId =
  //           this.tempSelectedAssignmentUsers[key]?.[0]?.id;
  //         if (selectedUserId) {
  //           const index = this.usersList.findIndex(
  //             (user: any) => user.id === selectedUserId
  //           );

  //           if (index !== -1) {
  //             //make that option disabled
  //             this.usersList[index].disabled = true;
  //             // this.usersList.splice(index, 1);
  //           }
  //           this.usersList = [...this.usersList];
  //         }
  //         // }
  //       });

  //     }

  //   } else {
  //     // clean tempSelectedAssignmentUsers
  //     this.tempSelectedAssignmentUsers[key] = [];
  //     //enable all usersList options
  //     this.usersList.forEach((user: any) => {
  //       user.disabled = false;
  //     });
  //     if (this.selectedData && !this.selectedData.assignment) {
  //       this.selectedData.assignment = {
  //         projectManager: [],
  //         director: [],
  //         accountManager: [],
  //         executive: [],
  //         seniorAccountManager: [],
  //         financeManager: [],
  //       };
  //     }
  //     if (this.selectedData) {
  //       Object.keys(this.selectedData.assignment).forEach((key) => {
  //         // if (key.includes('assignmentUser_')) {          
  //         // const selectedUserId = this.selectedData.assignment[key][0]?.id;
  //         const selectedUserId =
  //           this.tempSelectedAssignmentUsers[key]?.[0]?.id;
  //         if (selectedUserId) {
  //           const index = this.usersList.findIndex(
  //             (user: any) => user.id === selectedUserId
  //           );

  //           if (index !== -1) {
  //             //make that option disabled
  //             this.usersList[index].disabled = true;
  //             // this.usersList.splice(index, 1);
  //           }
  //           this.usersList = [...this.usersList];
  //         }
  //         // }
  //       });
  //     } else {
  //       Object.keys(this._fS.accountForm.controls).forEach((key) => {
  //         if (key.includes('assignmentUser_')) {
  //           //split key with _ to get the role
  //           const trimmedKey = key.split('_')[1];

  //           const selectedUserId =
  //             this.tempSelectedAssignmentUsers[trimmedKey]?.[0]?.id;

  //           if (selectedUserId) {
  //             const index = this.usersList.findIndex(
  //               (user: any) => user.id === selectedUserId
  //             );

  //             if (index !== -1) {
  //               //make that option disabled
  //               this.usersList[index].disabled = true;
  //               // this.usersList.splice(index, 1);
  //             }
  //             this.usersList = [...this.usersList];
  //           }
  //         }
  //       });
  //     }
  //   }
  //   this.usersList = [...this.usersList];

  // }

  disableEnableFromUsersList(event: string | null, key: string): void {
    // Ensure tempSelectedAssignmentUsers[key] exists
    if (!this.tempSelectedAssignmentUsers[key]) {
      this.tempSelectedAssignmentUsers[key] = [];
    }

    // Remove previously selected user for this key (if any)
    const prevSelected = this.tempSelectedAssignmentUsers[key][0];
    if (prevSelected) {
      const prevIndex = this.usersList.findIndex(user => user.id === prevSelected.id);
      if (prevIndex !== -1) {
        this.usersList[prevIndex].disabled = false;
      }
    }

    // Handle selection
    if (event) {
      const matchedUser = this.usersList.find(user => user.id === event);
      if (matchedUser) {
        this.tempSelectedAssignmentUsers[key] = [matchedUser];
      }
    } else {
      // Handle clear (deselection)
      this.tempSelectedAssignmentUsers[key] = [];
    }

    // Disable all selected users across all dropdowns
    this.usersList.forEach(user => {
      user.disabled = Object.values(this.tempSelectedAssignmentUsers).some(
        selectedArray => selectedArray[0]?.id === user.id
      );
    });

    // Re-assign to trigger UI update
    this.usersList = [...this.usersList];
  }

  onFileChanged(e: any) {
    let reader = new FileReader();
    if (
      e.target.files[0].length > 0 ||
      e.target.files[0].type === 'image/jpeg' ||
      e.target.files[0].type === 'image/png' ||
      e.target.files[0].type === 'image/jpg'
    ) {
      this.url = e.target.files[0];
      reader.readAsDataURL(this.url);
      reader.onload = () => {
        this.url = reader.result;
        this.isLoadingUpload = true;
        // this.isLoadingOne = true
        this._fS.fileupload.set('File', e.target.files[0]);
        this._fS.fileupload.set('Screen', 'AccountsProfile');

        this._cpS.fileUpload(this._fS.fileupload).subscribe(
          (response: any) => {
            if (response.responseStatus == ResponseStatus.success) {
              this.uploadResult = response.result[0];
              this._cS.displayMessage('success', response.message);
              this.isLoadingUpload = false;
            } else {
              this._cS.displayMessage('error', response.message);
              this.isLoadingUpload = false;
            }
          },
          (error: any) => {
            this.isLoadingUpload = false;
          }
        );
      };
    } else {
      this.msg.error('File type is not allowed');
      this.url = null;
      this.uploadResult = null;
      this.isLoadingUpload = false;
      // this.isLoadingOne = false
    }
  }

  removeLogo() {
    if (this.url != null) {
      var requestBody = {
        screen: 'AccountsProfile',
        filename: this.uploadResult,
      };
      this._cpS.fileDelete(requestBody).subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this._cS.displayMessage('success', response.message);

          this.url = '';
          this.uploadResult = null;
        } else {
          this._cS.displayMessage('error', response.message);
        }
      });
    }
  }
  handleChangeBulkUpload({ file }: NzUploadChangeParam) {
    this._fS.contractupload = new FormData();
    this.uploadedContractFiles = this.ListFile = [file];
    this.uploadedContractFile = file;

    //set contract date value to today date only if it is not set
    if (!this._fS.accountForm.get('contractDate').value) {
      this._fS.accountForm.patchValue({
        contractDate: new Date(),
      });
    }
    // set validators required for contract date field
    this._fS.accountForm.get('contractDate').setValidators([Validators.required]);
    this._fS.accountForm.get('contractDate').updateValueAndValidity();

    // for (var i = 0; i < this.uploadedContractFiles.length; i++) {
    this._fS.contractupload.set(
      'File',
      this.uploadedContractFiles[0].originFileObj
        ? this.uploadedContractFiles[0].originFileObj
        : this.uploadedContractFiles[0].name
    );

    if (this.uploadedContractFiles.length) {
      this._cpS
        .fileContractUpload(this._fS.contractupload)
        .subscribe((response: any) => {
          if (response.responseStatus == ResponseStatus.success) {
            this.ListFile = response.result;
          }
        });
    }
  }

  removeFile() {

    var requestBody = {
      screen: 'Account',
      filename: this.uploadedContractFiles[0].name,
    };
    this._cpS.fileDelete(requestBody).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        // this._cS.displayMessage('success', response.message);
        this.uploadedContractFile = null;
        this.uploadedContractFiles = [];
        this.ListFile = [];

        // remove validators for contract date field
        this._fS.accountForm.get('contractDate').clearValidators();
        this._fS.accountForm.get('contractDate').updateValueAndValidity();
        //reset contract date value to null
        this._fS.accountForm.patchValue({
          contractDate: null,
        });
      } else {
        this._cS.displayMessage('error', response.message);
      }
    });
  }

  beforeUpload = (file: NzUploadFile, _fileList: NzUploadFile[]): boolean => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (isJpgOrPng) {
      this._cS.displayMessage('warning', 'You cannot upload JPG or PNG file!');
      return false;
    } else {
      return true;
    }
  };

  getAllAccountTypesDropdown() {
    this._cpS.GetAllAccountTypesDropdown(this.SelectedAccountTab == AccountType.Operator ? this.SelectedAccountTab : 2).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.listOfType = response.result;
      }
    });
  }

  //get selected Account data while edit to patch
  getSelectedAccountDetails() {

    if (this.selectedData != null) {
      if (!this.selectedData?.assignment) {
        this._fS.accountForm.patchValue({
          assignedTo: AssignmentUser.AccountManager,
        });
        this.selectedData['assignment'] = {
          assignedTo: AssignmentUser.AccountManager
        }
        this.selectedRole = AssignmentUser.AccountManager;

      }
      this._fS.accountForm.patchValue({
        accountProfile: this.selectedData.profile,
        accountName: this.selectedData.name,
        address1: this.selectedData.address1,
        address2: this.selectedData.address2,
        city: this.selectedData.city,
        state: this.selectedData.state,
        zipcode: this.selectedData.zipcode,
        country: this.selectedData.country,
        agency: this.selectedData.agency.id,
        type: this.selectedData.type,
        assignedTo: this.selectedData?.assignment?.assignedTo,
        contractDate: this.selectedData.agreement.includes('0001') || this.selectedData.contractDoc?.length == 0
          ? null
          : new Date(this.selectedData.agreement),
        status: String(this.selectedData.status),
      });

      this.selectedRole = this.selectedData?.assignment?.assignedTo;
      if (this.selectedData?.assignment) {
        Object.keys(this.selectedData?.assignment).forEach((key) => {
          if (key != 'assignedTo') {
            const formControlKey =
              'assignmentUser_' + key.charAt(0).toLowerCase() + key.slice(1);

            if (this._fS.accountForm.controls[formControlKey] !== undefined) {
              if (this.selectedData.assignment[key]?.length) {
                const ids = this.selectedData.assignment[key][0]?.id;
                this._fS.accountForm.controls[formControlKey].patchValue(ids);
                this.tempSelectedAssignmentUsers[key] = this.selectedData.assignment[key];
              }
            }
          }
        });
        Object.keys(this.selectedData?.assignment).forEach((key) => {
          if (key != 'assignedTo') {

            const selectedUserId = this._fS.accountForm.controls['assignmentUser_' + key].value;
            if (selectedUserId) {
              const index = this.usersList.findIndex(
                (user: any) => user.id === selectedUserId
              );
              if (index !== -1) {
                //make that option disabled
                this.usersList[index].disabled = true;
              }
              this.usersList = [...this.usersList];
            }
          }
        });
      }

      this.LineStreetAddress = this.selectedData.isAddLine;
      this.url = this.selectedData.profile;
      this.ListFile = JSON.parse(JSON.stringify(this.selectedData.contractDoc));
      this.uploadedContractFiles = JSON.parse(
        JSON.stringify(this.selectedData.contractDoc)
      );

      if (this.selectedData.contractDoc?.length > 0) {
        this.uploadedContractFile = this.selectedData.contractDoc[0].fileLink;

        //set contract date validators required
        this._fS.accountForm.get('contractDate').setValidators([Validators.required]);
        this._fS.accountForm.get('contractDate').updateValueAndValidity();
      }
      if (this.uploadFlag == false) {
        this.uploadResult = this.selectedData.profile;
      }
      // if selectedAccountTab is AccountType.SupplierBank then disable the agency form field
      if (this.SelectedAccountTab == AccountType.SupplierBank) {
        this._fS.accountForm.get('agency')?.disable();
      }
    } else {
      this.tempSelectedAssignmentUsers = {
        projectManager: [],
        director: [],
        accountManager: [],
        executive: [],
        seniorAccountManager: [],
        financeManager: [],
      };
      //set selectedrole to accountManager
      this.selectedRole = AssignmentUser.AccountManager;
      //set form assignedTo value to AccountManager
      this._fS.accountForm.patchValue({
        assignedTo: AssignmentUser.AccountManager,
      });
    }
  }

  //close drawer
  handleCancel() {
    this.isVisibleAccountDrawer = false;
    this.hideAccountDrawer.emit({
      hide: this.isVisibleAccountDrawer,
      data: null,
    });

    this.tempSelectedAssignmentUsers = {
      projectManager: [],
      director: [],
      accountManager: [],
      executive: [],
      seniorAccountManager: [],
      financeManager: [],
    };
  }
  broofa() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }
  focusElement(event, element) {
    if (event) {
      element.focus();
    }
  }
  isAssignmentUserWarningModalVisible = false;

  //add or update button of drawer clicked
  handleOk() {
    if (this._fS.accountForm.valid) {
      if (this._fS.accountForm.controls['assignmentUser_' + AssignmentUser[this._fS.accountForm.value.assignedTo].charAt(0).toLowerCase() + AssignmentUser[this._fS.accountForm.value.assignedTo].slice(1)].value) {
        this.AddOrUpdateAccount();
      } else {
        this.isAssignmentUserWarningModalVisible = true;
      }

    } else {
      //to fire validations on invalid fields
      this._cS.markFormGroupTouched(this._fS.accountForm);
      if (this.selectedAccounts?.length == 0) {
        this.showAccountsInvalidMessage = true;
      }
      if (this.selectedSites?.length == 0) {
        this.showSitesInvalidMessage = true;
      }
    }
  }
  handleCancelAssignmentUserWarningModal() {
    this.isAssignmentUserWarningModalVisible = false;
  }
  AddOrUpdateAccount() {
    this.isAssignmentUserWarningModalVisible = false;
    //enable agency form field if selectedAccountTab is not AccountType.SupplierBank
    this._fS.accountForm.get('agency')?.enable();
    var selectedAgency = this.listOfAgencies.find(
      (agency: any) => agency._id == this._fS.accountForm.value.agency
    );
    const formValue = this._fS.accountForm.value;
    // this.userDetails = localStorage.getItem('userdetails');

    //find name from usersList for formValue.assignmentUser_ProjectManager and other fields to form array of id and name json
    const selectedProjectManagers = formValue.assignmentUser_projectManager
      ? this.usersOGList.filter((user: any) =>
        formValue.assignmentUser_projectManager == user.id
      )
      : [];
    const selectedDirectors = formValue.assignmentUser_director
      ? this.usersOGList.filter((user: any) =>
        formValue.assignmentUser_director == (user.id)
      )
      : [];
    const selectedAccountManagers = formValue.assignmentUser_accountManager
      ? this.usersOGList.filter((user: any) =>
        formValue.assignmentUser_accountManager == user.id
      )
      : [];
    const selectedExecutives = formValue.assignmentUser_executive
      ? this.usersOGList.filter((user: any) =>
        formValue.assignmentUser_executive == user.id
      )
      : [];
    const selectedSeniorAccountManagers =
      formValue.assignmentUser_seniorAccountManager
        ? this.usersOGList.filter((user: any) =>
          formValue.assignmentUser_seniorAccountManager == user.id
        )
        : [];
    const selectedFinanceManagers = formValue.assignmentUser_financeManager
      ? this.usersOGList.filter((user: any) =>
        formValue.assignmentUser_financeManager == user.id
      )
      : [];

    var accountBody = {
      Id: this.selectedData != null ? this.selectedData.id : this.broofa(),
      Name: formValue.accountName.trim(),
      Profile: this.uploadResult,
      Address1: formValue.address1,
      Address2: formValue.address2,
      City: formValue.city,
      State: formValue.state,
      Zipcode: formValue.zipcode,
      Country: formValue.country,
      Agency: {
        Id: selectedAgency._id,
        Name: selectedAgency.Name,
      },
      Type: formValue.type,
      Agreement: this.ListFile?.length > 0 ? formValue.contractDate : null,
      ContractDoc: this.ListFile,
      Status: formValue.status,
      isAddLine: this.LineStreetAddress,
      Assignment: {
        ProjectManager: selectedProjectManagers,
        Director: selectedDirectors,
        AccountManager: selectedAccountManagers,
        Executive: selectedExecutives,
        SeniorAccountManager: selectedSeniorAccountManagers,
        FinanceManager: selectedFinanceManagers,
        AssignedTo: formValue.assignedTo,
      },
    };
    //add or edit Account data
    if (this.selectedData != null) {
      this.UpdateAccountData(accountBody);
    } else {
      this.addAccountData(accountBody);
    }
  }
  //api call to add/update agency
  addAccountData(accountBody: any) {
    this.isLoadingOne = true;
    // this._cpS.fileContractUpload(this._fS.contractupload).subscribe(
    //   (response: any) => {
    //     if (response.responseStatus == ResponseStatus.success) {
    //       // for (var i = 0; i < response.result.length; i++) {
    //       //   this.contractArr.push({ name: this.ListFile[i].name, fileLink: response.result[i] })
    //       // }
    //       accountBody.ContractDoc = response.result;
    // accountBody = JSON.stringify(accountBody)
    this._cpS.createAccount(accountBody).subscribe(
      (response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this._cS.displayMessage('success', response.message);

          //hide unit drawer
          this.isVisibleAccountDrawer = false;
          this.hideAccountDrawer.emit({
            hide: this.isVisibleAccountDrawer,
            data: response.result,
          });
          this.isLoadingOne = false;
          this.tempSelectedAssignmentUsers = {
            projectManager: [],
            director: [],
            accountManager: [],
            executive: [],
            seniorAccountManager: [],
            financeManager: [],
          };
        } else {
          this._cS.displayMessage('error', response.message);
          this.isLoadingOne = false;
        }
      },
      (error: any) => {
        // this._cS.displayMessage('error', error.message);
        this.isLoadingOne = false;
      }
    );
    //   } else {
    //     this._cS.displayMessage('error', response.message);
    //   }
    // },
    // (error: any) => {
    //   // this._cS.displayMessage('error', error.message);
    // }
    // );
  }
  //api call to add/update account
  UpdateAccountData(accountBody: any) {
    this.isLoadingOne = true;
    // this._cpS.fileUpload(this._fS.contractupload).subscribe((response: any) => {
    //   if (response.responseStatus == ResponseStatus.success) {
    //     for (var i = 0; i < response.result.length; i++) {
    //       this.contractArr.push({
    //         Name: this.ListFile[i].name,
    //         FileLink: response.result[i],
    //       });
    //     }
    //     accountBody.ContractDoc = this.contractArr;
    //     accountBody = JSON.stringify(accountBody);
    this._cpS.updateAccount(accountBody).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this._cS.displayMessage('success', response.message);

        //hide accoount drawer
        this.isVisibleAccountDrawer = false;
        this.tempSelectedAssignmentUsers = {
          projectManager: [],
          director: [],
          accountManager: [],
          executive: [],
          seniorAccountManager: [],
          financeManager: [],
        };
        this.hideAccountDrawer.emit({
          hide: this.isVisibleAccountDrawer,
          data: response.result,
        });
        this.isLoadingOne = false;
      } else {
        this._cS.displayMessage('error', response.message);
        this.isLoadingOne = false;
      }
    });
    //   } else {
    //     this._cS.displayMessage('error', response.message);
    //   }
    // });
  }

  getAllAgencys() {
    this._iS.GetAgencyDropdownList().subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.listOfAgencies = response.result;
        //if selectedAccountTab is Account.Operator then filter agencies except Supplier Bank agency
        if (this.SelectedAccountTab == AccountType.Operator) {
          this.listOfAgencies = this.listOfAgencies.filter((item: any) => {
            return item.Name != 'Supplier Bank';
          });
        } else if (this.SelectedAccountTab == AccountType.Supplier) {
          this.listOfAgencies = this.listOfAgencies.filter((item: any) => {
            return item.Name == 'Supplier';
          });
          if (this.listOfAgencies?.length) {
            this._fS.accountForm.patchValue({
              agency: this.listOfAgencies[0]._id,
            });
            this._fS.accountForm.get('agency')?.disable();
          }
        } else if (this.SelectedAccountTab == AccountType.SupplierBank) {
          this.listOfAgencies = this.listOfAgencies.filter((item: any) => {
            return item.Name == 'Supplier Bank';
          });
          if (this.listOfAgencies?.length) {
            this._fS.accountForm.patchValue({
              agency: this.listOfAgencies[0]._id,
            });
            this._fS.accountForm.get('agency')?.disable();
          }
        }
      }
    });
  }

  deleteFile(index: any) {
    if (this.ListFile.length) {
      this.ListFile.splice(index, 1);
    }
    if (this.uploadedContractFiles.length) {
      this.uploadedContractFiles.splice(index, 1);
    }
  }

  addLines() {
    this.LineStreetAddress = true;
    this._fS.accountForm.patchValue({
      address1:
        this._fS.accountForm.get('address1').value != null &&
          this._fS.accountForm.get('address1').value != ''
          ? this._fS.accountForm.get('address1').value +
          '\r\n' +
          this._fS.accountForm.get('address2').value
          : this._fS.accountForm.get('address2').value,
      address2: '',
    });
  }
}
